import { render, staticRenderFns } from "./OtherActivities.vue?vue&type=template&id=73406c89"
import script from "./OtherActivities.vue?vue&type=script&lang=js"
export * from "./OtherActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports